import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import Loader from "src/components/loader/loader";
import { useAppSelector } from "../../hooks/redux";
const CreateBasket = () => {
    const CreateBasketModal = React.lazy(() => import("src/modals/create-basket/create-basket"));
    const createBasketVisibility = useAppSelector((state) => state.modals.createBasketVisibility);
    return (_jsx(_Fragment, { children: createBasketVisibility && (_jsx(React.Suspense, Object.assign({ fallback: _jsx(Loader, {}) }, { children: _jsx(CreateBasketModal, {}) }))) }));
};
export default CreateBasket;
